import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ProductRow } from '@app/lists/shared/list-detail-management/model/list-detail-management-view.model';
import { EllipsisClickData } from '@shared/models/usf-product-card.model';
import { EasyPricingUpdate, ManualUpdateReason } from '@usf/ngrx-pricing';
import { ManualApprovalComponent } from '../manual-approval/manual-approval.component';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-usf-pme-product-card',
  templateUrl: './usf-pme-product-card.component.html',
  styleUrls: ['./usf-pme-product-card.component.scss'],
})
export class UsfPmeProductCardComponent {
  @Input() index: number;
  @Input() product: ProductRow;
  @Input() isOnline: boolean;
  @Input() screenWidth: number;
  @Input() isSelected = false;
  @Input() showNote = false;
  @Input() isTouch: boolean;
  @Input() hideLowLimit: boolean;

  @Output() clicked = new EventEmitter<ProductRow>();
  @Output() priceChanged = new EventEmitter<EasyPricingUpdate>();
  @Output() itemNoteClick = new EventEmitter<EllipsisClickData>();
  @Output() infoIconClick = new EventEmitter<EllipsisClickData>();
  @Output() bannerClick = new EventEmitter<EllipsisClickData>();
  @Output() closeManualApproval = new EventEmitter<number>();

  @ViewChild('popover') popover!: HTMLIonPopoverElement;
  @ViewChild('manualApprovalComponent')
  manualApprovalComponent!: ManualApprovalComponent;

  isPopoverOpen = false;
  manualApprovalReason: ManualUpdateReason;

  customPricingPopoverOptions = {
    showBackdrop: false,
    cssClass: 'manual-pricing-popover',
    mode: 'ios',
    alignment: 'center',
  };

  constructor(private platformService: PlatformService) {}

  onProductClick(event?: Event) {
    if (event) {
      const target = event?.target as HTMLElement;

      if (
        target?.closest('ion-input') ||
        target?.closest('.custom-price-input') ||
        target?.closest('.price-change-container-wrapper') ||
        this.isSelected
      ) {
        return;
      }
    }

    event?.stopPropagation();
    this.clicked.emit(this.product);
  }

  selectTargetPrice(event: Event): void {
    event.stopPropagation();
    if (
      this.platformService.platformType !==
      this.platformService.platformEnum.mobile
    ) {
      this.clicked.emit(this.product);
    }
    this.priceChanged.emit({
      isManualUpdate: false,
      productNumber: this.product.productNumber,
      price: this.product.easyPricingViewModel.targetCasePrice,
      isCustomUpdate: false,
      productUOM: this.product.summary.priceUom,
      trackingAttributes: this.product.trackingAttributes,
    });
  }

  onCustomPriceFocus(event: Event): void {
    event.stopPropagation();
    if (
      this.platformService.platformType !==
        this.platformService.platformEnum.mobile &&
      !this.isSelected
    ) {
      this.clicked.emit(this.product);
    }
  }

  onCustomPriceChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const customPrice = parseFloat(value?.replace(/[^0-9.]/g, ''));

    if (
      customPrice &&
      customPrice !== this.product?.easyPricingViewModel?.currentUnitPrice
    ) {
      this.priceChanged.emit({
        isManualUpdate: false,
        productNumber: this.product.productNumber,
        price: customPrice,
        isCustomUpdate: true,
        productUOM: this.product.summary.priceUom,
        trackingAttributes: this.product.trackingAttributes,
      });
    }
  }

  itemNoteClicked() {
    this.itemNoteClick.emit({
      product: this.product,
    } as EllipsisClickData);
  }

  onInfoIconClick() {
    this.infoIconClick.emit({
      product: this.product,
    } as EllipsisClickData);
  }

  onBannerClick() {
    this.bannerClick.emit({
      product: this.product,
    } as EllipsisClickData);
  }

  openPopover(event: Event) {
    event.stopPropagation();
    this.popover.event = event;
    this.isPopoverOpen = true;
  }

  onManualApprovalSubmit(event: Event) {
    event.stopPropagation();
    this.priceChanged.emit({
      isManualUpdate: true,
      productNumber: this.product.productNumber,
      price: this.product.easyPricingViewModel.customPrice,
      isCustomUpdate: true,
      productUOM: this.product.summary.priceUom,
      manualUpdateReason: this.manualApprovalReason,
      trackingAttributes: this.product.trackingAttributes,
    });
  }

  onReasonSelected(reason: ManualUpdateReason) {
    this.manualApprovalReason = reason;
  }

  onCloseManualApproval() {
    this.closeManualApproval.emit(this.product.productNumber);
  }
}
